import gql from 'graphql-tag'

const statsHomeRiepilogoContattiAppuntamenti = gql`
  query statsHomeRiepilogoContattiAppuntamenti (
    $daData: Date!,
    $aData: Date!
  ) {
    statsHomeRiepilogoContattiAppuntamenti (
      daData: $daData,
      aData: $aData
    ) {
      numeroContatti
      numeroContattiSenzaRisposta
      numeroAppuntamentiFissati
      numeroAppuntamentiDaConfermare
    }
  }
`

export default statsHomeRiepilogoContattiAppuntamenti


// WEBPACK FOOTER //
// ./src/graphql/queries/statsHomeRiepilogoContattiAppuntamenti.js